import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import "./DisableLogs";
import { lazy, Suspense } from "react";
import Loader from "./components/Loader";
const App = lazy(() => import("./App"));
const JazzCashApp = lazy(() => import("./JazzCash"));

const jazzCashRoutes = ["/jc", "/landingjazzcash"];

const resovleApp = () => {
  const path = window.location.pathname;
  if (jazzCashRoutes.some((route) => path.startsWith(route))) {
    return <JazzCashApp />;
  }

  // Default to main app
  return <App />;
};
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <BrowserRouter>
    <Suspense fallback={<Loader />}>{resovleApp()}</Suspense>
  </BrowserRouter>,
);
reportWebVitals();
